import axios, { AxiosError, AxiosResponse } from 'axios'

import { ApiServiceResult, StatusCodes } from '@/common/contracts'
import { ApplicationException } from '@/common/exceptions'
import { getParsedException } from '@/common/helpers'

interface ApiServiceParams<RequestData> {
  resource: string
  method: 'delete' | 'get' | 'patch' | 'post' | 'put'
  url: string
  baseURL?: string
  params?: RequestData
  body?: RequestData
  headers?: Record<string, unknown>
}

const axiosClient = axios.create({
  timeout: 20000
})

export async function apiService<RequestData, ResponseData>({
  resource,
  method,
  url,
  baseURL,
  params,
  body,
  headers
}: ApiServiceParams<RequestData>): Promise<ApiServiceResult<ResponseData>> {
  return axiosClient
    .request<ApiServiceParams<RequestData>['body'], AxiosResponse<ResponseData>>({
      method,
      url,
      baseURL,
      params,
      data: body,
      headers: {
        ...axiosClient.defaults.headers,
        ...headers
      } as Record<string, string>
    })
    .then((res) => ({ data: res.data, headers: res.headers as Record<string, string> }))
    .catch((error: AxiosError<ApplicationException>) => {
      const parsedError = (error.response?.data ?? error) as ApplicationException
      parsedError.statusCode = error.response?.status ?? StatusCodes.INTERNAL
      throw getParsedException(resource, parsedError)
    })
}
